import {Paper} from "@mui/material";
import {sx} from './sx'

const ViewDatePicker = ({children}) => {

    return (
        <Paper
            elevation={3}
            sx={sx.root}
        >
            {children}
        </Paper>
    )
};

export default ViewDatePicker